var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarningInfo = function SvgWarningInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1992 12.5215C21.1992 17.492 17.1698 21.5215 12.1992 21.5215C7.22866 21.5215 3.19922 17.492 3.19922 12.5215C3.19922 7.55092 7.22866 3.52148 12.1992 3.52148C17.1698 3.52148 21.1992 7.55092 21.1992 12.5215ZM23.1992 12.5215C23.1992 18.5966 18.2744 23.5215 12.1992 23.5215C6.12409 23.5215 1.19922 18.5966 1.19922 12.5215C1.19922 6.44635 6.12409 1.52148 12.1992 1.52148C18.2744 1.52148 23.1992 6.44635 23.1992 12.5215ZM10.6992 17.0215C10.6992 16.1931 11.3708 15.5215 12.1992 15.5215C13.0276 15.5215 13.6992 16.1931 13.6992 17.0215C13.6992 17.8499 13.0276 18.5215 12.1992 18.5215C11.3708 18.5215 10.6992 17.8499 10.6992 17.0215ZM12.1992 6.02148C12.7515 6.02148 13.1992 6.4692 13.1992 7.02148V13.0215C13.1992 13.5738 12.7515 14.0215 12.1992 14.0215C11.6469 14.0215 11.1992 13.5738 11.1992 13.0215V7.02148C11.1992 6.4692 11.6469 6.02148 12.1992 6.02148Z",
    fill: "#FF9500"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warningInfo.f44c04eb.svg";
export { ForwardRef as ReactComponent };